import React from 'react';
import AppListToolbarGlobal, { type CompanyOption } from '@/__core/components/AppLisstToolbarGlobal';

export interface RequestMaterialToolbarGlobalProps {
  /** @deprecated Chỉ dùng khi test; mặc định lấy từ auth + resolveModuleAccessibleCompanies */
  companies?: CompanyOption[];
  fetchCompanies?: () => Promise<CompanyOption[]>;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: () => void;
  onToggleAdvancedSearch?: () => void;
  isAdvancedSearchOpen?: boolean;
  onFilterChange?: (field: string, value: string) => void;

  filters?: {
    company: string;
    status: string;
    requestType: string;
  };
  statusOptions?: Array<{ id: string; name: string }>;
  requestTypeOptions?: Array<{ id: string; name: string }>;
}

export default function RequestMaterialToolbarGlobal({
  companies,
  searchQuery = '',
  onSearchChange,
  onSearchSubmit,
  onToggleAdvancedSearch,
  isAdvancedSearchOpen = false,
  filters = { company: 'all', status: 'all', requestType: 'all' },
  onFilterChange,
  statusOptions = [],
  requestTypeOptions = [],
}: RequestMaterialToolbarGlobalProps) {
  const statusFilterOptions = React.useMemo(
    () => statusOptions.map((option) => ({ value: option.id, label: option.name })),
    [statusOptions]
  );

  const requestTypeFilterOptions = React.useMemo(
    () => requestTypeOptions.map((option) => ({ value: option.id, label: option.name })),
    [requestTypeOptions]
  );

  const advancedFilterFields = React.useMemo(
    () => [
      {
        key: 'status',
        label: 'Trạng thái',
        labelWidth: 90,
        value: filters.status,
        placeholder: 'Chọn trạng thái',
        options: statusFilterOptions,
        onChange: (value: string) => onFilterChange?.('status', value),
        gridSize: { xs: 12, sm: 6, md: 6 },
      },
      {
        key: 'requestType',
        label: 'Loại request',
        labelWidth: 90,
        value: filters.requestType,
        placeholder: 'Chọn loại request',
        options: requestTypeFilterOptions,
        onChange: (value: string) => onFilterChange?.('requestType', value),
        gridSize: { xs: 12, sm: 6, md: 6 },
      },
    ],
    [filters.requestType, filters.status, onFilterChange, requestTypeFilterOptions, statusFilterOptions]
  );

  return (
    <AppListToolbarGlobal
      scopeModule='request-material'
      companies={companies}
      searchPlaceholder='Tìm theo mã request, mã đơn hàng, người tạo, ghi chú...'
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      onSearchSubmit={onSearchSubmit}
      isAdvancedSearchOpen={isAdvancedSearchOpen}
      onToggleAdvancedSearch={onToggleAdvancedSearch}
      selectedCompany={filters.company}
      onCompanyChange={(id) => onFilterChange?.('company', id)}
      advancedFilterFields={advancedFilterFields}
    />
  );
}
